/**
 * Formata critérios de regra de comissão para exibição no Relatório de Conversões.
 */

export function parseCommissionRuleCriteria(raw) {
  if (!raw) {
    return [];
  }

  if (Array.isArray(raw)) {
    return raw;
  }

  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  return [];
}

export function commissionRuleCriterionValue(criterion) {
  if (criterion.operator === 'in') {
    return (criterion.values || []).join(', ');
  }

  if (criterion.operator === 'between') {
    return `${criterion.value_min} - ${criterion.value_max}`;
  }

  return criterion.value;
}

export function commissionRuleCriterionLabel(criterion, translate) {
  const operator = translate(`operator_${criterion.operator}`);
  const name = criterion.name || criterion.parameter;

  return `${name} (${criterion.parameter}) ${operator} ${commissionRuleCriterionValue(criterion)}`;
}

export function commissionRuleCriteriaTooltip(criteria, translate) {
  return parseCommissionRuleCriteria(criteria).map((criterion) => commissionRuleCriterionLabel(criterion, translate));
}
